import { userInfoField, webTitle } from "@/config/config";

const userInfo = sessionStorage.getItem(userInfoField);

export default userInfo ? JSON.parse(userInfo) : userInfo;